"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateQuestion = exports.updateInputNumberValidation = exports.setDefaultValueHanlder = exports.correctNumberValue = exports.correctDefaultValue = exports.convertOutputData = exports.ValidationSupport = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var Survey = _interopRequireWildcard(require("survey-core"));
var _bigDecimal = _interopRequireDefault(require("../../bigDecimal"));
var _constants = _interopRequireDefault(require("../../constants"));
var _constants2 = require("./constants");
var _constants3 = require("../toolboxCustom/constants");
var _surveyModelWrapper = _interopRequireDefault(require("./surveyModelWrapper"));
var _customQuestionDateTime = require("./date/customQuestionDateTime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var handleUpdateQuestion = function handleUpdateQuestion(refElement) {
  var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return null;
  };
  if (!_lodash.default.isNil(refElement)) {
    for (var j = 0; j < refElement.length; j += 1) {
      var question = refElement[j];
      if (question.type === 'panel') {
        handleUpdateQuestion(question.elements, handler);
      } else if (question.type !== 'header') {
        handler(question);
      }
    }
  }
};
var updateQuestion = function updateQuestion(configJson, handler) {
  var pages = _lodash.default.get(configJson, 'pages', []);
  pages.forEach(function (p) {
    handleUpdateQuestion(p.elements, handler);
  });
};
exports.updateQuestion = updateQuestion;
var correctNumberValue = function correctNumberValue(value) {
  if (typeof value === 'string' && Survey.Helpers.isNumber(value)) {
    return new _bigDecimal.default(value).toString();
  }
  if (typeof value === 'number') {
    return new _bigDecimal.default(value.toString()).toString();
  }
  return value;
};
exports.correctNumberValue = correctNumberValue;
var correctDefaultValue = function correctDefaultValue(question, inputValue) {
  // Handle item in choices list items
  if (question.choices && inputValue) {
    if (_lodash.default.isArray(inputValue)) {
      var itemChoice = question.choices.filter(function (item) {
        return inputValue.includes(item.value) || inputValue.includes(item);
      }).map(function (item) {
        return item.text || item.value || item;
      });
      if (!_lodash.default.isEmpty(itemChoice)) {
        return itemChoice;
      }
      if (inputValue.includes('none') && question.hasNone) {
        if (question.noneText && question.noneText !== '') {
          return [question.noneText];
        }
        return ['None'];
      }
    } else {
      var _itemChoice = question.choices.find(function (item) {
        return item.value === inputValue;
      });
      if (_itemChoice) {
        return _itemChoice.text;
      }
      if (inputValue === 'none' && question.hasNone) {
        if (question.noneText && question.noneText !== '') {
          return question.noneText;
        }
        return 'None';
      }
    }
  }
  if (question.internalType === 'boolean' && (typeof inputValue === 'boolean' || !!inputValue)) {
    var booleanValue = _lodash.default.isString(inputValue) ? inputValue === 'true' : inputValue;
    if (booleanValue) {
      return question.labelTrue || _constants2.BOOLEAN_LABEL.YES;
    }
    return question.labelFalse || _constants2.BOOLEAN_LABEL.NO;
  }
  if (question.getType() === 'dateCustom') {
    return (0, _customQuestionDateTime.convertValueToDisplay)(inputValue, (0, _customQuestionDateTime.getDateFormat)(question), question.internalType);
  }
  return null;
};
exports.correctDefaultValue = correctDefaultValue;
var setDefaultValueHanlder = function setDefaultValueHanlder(question, defaultValueObject) {
  var internalQuestion = question;
  var _Constants$DateTimeFo = _constants.default.DateTimeFormat,
    shortDate = _Constants$DateTimeFo.shortDate,
    defaultSurveyDate = _Constants$DateTimeFo.defaultSurveyDate,
    dateTimeAMPM = _Constants$DateTimeFo.dateTimeAMPM,
    defaultSurveyDateTime = _Constants$DateTimeFo.defaultSurveyDateTime;
  if (defaultValueObject && question.name in defaultValueObject && defaultValueObject[question.name] !== '' && question.visible !== false) {
    internalQuestion.defaultValueExpression = undefined;
    switch (question.internalType) {
      case _constants2.DATE_TYPE.DATE_TIME:
        if (defaultValueObject[question.name]) {
          internalQuestion.defaultValue = (0, _momentTimezone.default)(defaultValueObject[question.name], dateTimeAMPM, true).format(defaultSurveyDateTime);
        }
        break;
      case _constants2.DATE_TYPE.DATE:
        if (defaultValueObject[question.name]) {
          internalQuestion.defaultValue = (0, _momentTimezone.default)(defaultValueObject[question.name], shortDate, true).format(defaultSurveyDate);
        }
        break;
      default:
        internalQuestion.defaultValue = defaultValueObject[question.name];
    }
  }
};

/**
 * Update regex for input number
 * @param {String} configJson cloned value
 */
exports.setDefaultValueHanlder = setDefaultValueHanlder;
var updateInputNumberValidation = function updateInputNumberValidation(configJson) {
  updateQuestion(configJson, function (question) {
    if (question.type === 'text' && question.internalType === _constants3.TOOLBOX_TYPE.NUMBERS) {
      var validators = question.validators;
      _lodash.default.update(question, 'inputType', function () {
        return 'text';
      });
      _lodash.default.update(question, 'inputMask', function () {
        return {
          numericInput: true
        };
      });
      _lodash.default.update(question, 'defaultValue', function () {
        return correctNumberValue(question.defaultValue);
      });
      if (!_lodash.default.isNil(validators)) {
        validators.forEach(function (validation) {
          _lodash.default.update(validation, 'regex', function () {
            return _constants3.NUMBER_INPUT_REGEX;
          });
        });
      }
    }
  });
};

/**
 * Convert survey data before output to outsite survey preview component
 * @param {Object} survey
 * @returns a new survey object with converted values
 */
exports.updateInputNumberValidation = updateInputNumberValidation;
var convertOutputData = function convertOutputData(survey) {
  if (!survey) return null;
  var questions = survey.getAllQuestions();
  var convertedData = _lodash.default.cloneDeep(survey.data);

  // Convert value of date, date & time from survey format to display format
  var dateTimeQuestions = questions.filter(function (question) {
    return [_constants2.DATE_TYPE.DATE, _constants2.DATE_TYPE.DATE_TIME].includes(question.internalType);
  });
  dateTimeQuestions.forEach(function (question) {
    if (_lodash.default.has(survey.data, question.name)) {
      convertedData[question.name] = (0, _customQuestionDateTime.convertValueToDisplay)(survey.data[question.name], (0, _customQuestionDateTime.getDateFormat)(question), question.internalType);
    }
  });
  var convertedSurvey = new _surveyModelWrapper.default(survey);
  convertedSurvey.data = convertedData;
  return convertedSurvey;
};
exports.convertOutputData = convertOutputData;
var ValidationSupport = {
  /**
    * custom validate DateTime question
    * @param {Object} options
  */
  validateDateTimeQuestion: function validateDateTimeQuestion(options) {
    if (_lodash.default.isEmpty(options.value)) return;
    var surveyDateFormat = (0, _customQuestionDateTime.getSurveyDateFormat)(options.question);
    if (_lodash.default.includes(_constants2.DATE_TYPE, options.question.internalType)) {
      if ((0, _momentTimezone.default)(options.value, surveyDateFormat, true).isValid()) {
        return;
      }
    }
    var displayDateFormat = (0, _customQuestionDateTime.getDateFormat)(options.question);
    var internalOptions = options;
    internalOptions.error = _constants2.DATE_INVALID_FORMAT.replace('{QUESTION_TITLE}', options.question.title).replace('{DATE_FORMAT}', displayDateFormat);
  },
  /**
    * custom validate Boolean question
    * @param {Object} options
  */
  validateBooleanQuestion: function validateBooleanQuestion(options) {
    var _options$question = options.question,
      defaultValue = _options$question.defaultValue,
      value = _options$question.value;
    if (defaultValue !== null && defaultValue !== undefined && (value === null || value === undefined)) {
      var internalOptions = options;
      internalOptions.error = _constants2.INVALID_UPLOAD_ANSWER;
    }
  },
  /**
    * custom validate Number question
    * @param {Object} options
  */
  validateNumberQuestion: function validateNumberQuestion(options) {
    var internalOptions = options;
    var optionValue = options.question.value || options.question.defaultValue;
    if (optionValue && optionValue !== '') {
      if (!Survey.Helpers.isNumber(optionValue)) {
        internalOptions.error = Survey.surveyLocalization.getString('numericError');
      } else {
        var _internalOptions$ques = internalOptions.question,
          min = _internalOptions$ques.min,
          max = _internalOptions$ques.max;
        var bigValue = new _bigDecimal.default(optionValue);
        if (min && bigValue.comparedTo(min) === -1) {
          internalOptions.error = "The value should not be less than ".concat(min);
        } else if (max && bigValue.comparedTo(max) === 1) {
          internalOptions.error = "The value should not be greater than ".concat(max);
        }
      }
    } else {
      internalOptions.error = '';
    }
  }
};
exports.ValidationSupport = ValidationSupport;